<template>
  <div>
    <b-card no-body>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
        fixed
        empty-text="Henüz yüklenmiş doküman bulunmuyor."
        :show-empty="!dataList.length"
      >
        <template #cell(title)="data">
          <div>
            {{ data.item.title }}
          </div>
          <div class="text-info font-small-3">
            {{ moment(data.item.created).format('DD.MM.YYYY') }} - {{ data.item.username }}
          </div>
        </template>
        <template #cell(control)="data">
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              size="sm"
              :href="data.item.filename"
              target="_blank"
            >
              <FeatherIcon icon="DownloadIcon" />
              Dosya İndir
            </b-button>
            <b-button
              variant="flat-danger"
              size="sm"
              class="ml-1 btn-icon"
              pill
              @click="removeData(data.item.id)"
            >
              <FeatherIcon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-card-body v-if="uploading">
        <pre-loading />
      </b-card-body>
      <b-card-body v-else>
        <b-form-group
          label="Belge Adı"
          label-for="title"
        >
          <b-form-input
            id="title"
            v-model="title"
            placeholder="Belge Adı"
          />
        </b-form-group>
        <b-form-group
          label="Doküman Yükle"
          label-for="file-upload"
        >
          <b-form-file
            id="file-upload"
            v-model="upload_file"
            placeholder="Bir dosya seçin veya buraya bırakın..."
            drop-placeholder="Dosyayı buraya bırakın..."
            browse-text="Dosya Seçin"
          />
        </b-form-group>
        <div class="text-center mt-1">
          <b-button
            variant="success"
            :disabled="!upload_file"
            @click="uploadFile"
          >
            <FeatherIcon icon="UploadIcon" />
            Dosya Yükle
          </b-button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTable, BCardBody, BFormGroup, BFormFile, BButton, BFormInput,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'DocumentCard',
  components: {
    PreLoading,
    BCard,
    BTable,
    BCardBody,
    BFormGroup,
    BFormFile,
    BFormInput,
    BButton,
  },
  data() {
    return {
      title: null,
      upload_file: null,
      fields: [
        {
          key: 'title',
          label: 'Doküman Adı',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-250 text-nowrap text-center',
          tdClass: 'width-250 text-nowrap text-center',
        },
      ],
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['estateDocuments/dataList']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('estateDocuments/getDataList', {
        where: {
          id_estates: this.$route.params.id,
        },
      })
    },
    uploadFile() {
      this.$store.dispatch('fileUpload/uploadFile', {
        title: this.title,
        folder: 'estate_documents',
        ordering: '1',
        component: 'estate_documents',
        params: 'document',
        item_id: this.$route.params.id,
        upload_file: this.upload_file,
      })
        .then(response => {
          if (response.status) {
            this.getDataList()
          }
        })
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('estateDocuments/removeData', id)
            .then(response => {
              if (response) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.getDataList()
              }
            })
        }
      })
    },
  },
}
</script>
